/**
 * Section – wrapper for preview page sections (e.g. Get in touch).
 */

import React from "react";

export interface SectionProps {
  children: React.ReactNode;
  className?: string;
}

export function Section({ children, className }: SectionProps) {
  return <section className={className}>{children}</section>;
}
